!(function () {
  var t = {
      8798: function () {
        window.latinCharacters = function (t) {
          var e =
              /^[a-zA-ZÆØÅæøåÂÃÊÔŠŽÄËÏÖÜâêôšžäëïöüÁÉÍÓÚÀÈÌÒÙÑáéíóúàèìòù´¨ñÕõÇçÐðÝÞßýþÿ0-9!@#$%^&*()_=. -]+$/,
            i = /[\\ĄĆĘŁŃÓŚŹŻżŻśżńółęćąí"`|?/,*<>&]|&quot;/;
          t &&
            t.addEventListener("input", function () {
              for (var o = t.value, n = "", r = 0; r < o.length; r++)
                e.test(o[r]) && !i.test(o[r]) && (n += o[r]);
              n.includes("--") && (n = n.replace(/--+/g, "-")), (t.value = n);
            });
        };
      },
      6426: function () {
        document.addEventListener("DOMContentLoaded", function () {
          setTimeout(function () {
            var t = document.getElementById("showCategory"),
              e = document.getElementById("hideCategory"),
              i = document.getElementById("cookieCategories"),
              o = document.getElementById("coi-banner-wrapper"),
              n = document.getElementById("show_details"),
              r = document.getElementById("hide_details"),
              a = document.getElementById("declineButton"),
              s = document.getElementById("updateButton"),
              l = document.querySelectorAll(".coi__checkbox");
            t?.addEventListener("click", function (n) {
              t.classList.remove("show"),
                i.classList.add("show"),
                o.classList.add("show-70"),
                e.classList.add("show");
            }),
              e?.addEventListener("click", function (n) {
                t.classList.add("show"),
                  i.classList.remove("show"),
                  o.classList.remove("show-70"),
                  e.classList.remove("show");
              }),
              n?.addEventListener("click", function (t) {
                o.classList.add("show-100");
              }),
              r?.addEventListener("click", function (t) {
                o.classList.remove("show-100");
              }),
              l?.forEach(function (t) {
                t?.addEventListener("click", function (t) {
                  a.classList.add("hide"), s.classList.add("show");
                });
              });
          }, 2e3);
        });
      },
      8067: function () {
        var t;
        (t = "header.header a"),
          document.querySelectorAll(t).forEach(function (t) {
            t.addEventListener("click", function (t) {
              window.sessionStorage.removeItem("last_product_clicked_url");
            });
          });
      },
      4932: function () {
        (window.createLoadingIcon = function () {
          var t = document.createElement("div");
          t.classList.add("products_loading"),
            (t.innerHTML =
              '<?xml version="1.0" encoding="utf-8"?><svg height=100px preserveAspectRatio=xMidYMid style="margin:auto;background:0 0;display:block;shape-rendering:auto"viewBox="0 0 100 100"width=100px xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink><g transform="rotate(0 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=-0.9166666666666666s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g><g transform="rotate(30 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=-0.8333333333333334s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g><g transform="rotate(60 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=-0.75s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g><g transform="rotate(90 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=-0.6666666666666666s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g><g transform="rotate(120 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=-0.5833333333333334s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g><g transform="rotate(150 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=-0.5s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g><g transform="rotate(180 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=-0.4166666666666667s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g><g transform="rotate(210 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=-0.3333333333333333s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g><g transform="rotate(240 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=-0.25s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g><g transform="rotate(270 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=-0.16666666666666666s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g><g transform="rotate(300 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=-0.08333333333333333s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g><g transform="rotate(330 50 50)"><rect fill=#797979 height=1 rx=0 ry=0 width=5 x=47 y=34.5><animate attributeName=opacity begin=0s dur=1s keyTimes=0;1 repeatCount=indefinite values=1;0></animate></rect></g></svg>'),
            document.querySelector("body").appendChild(t);
        }),
          (window.showLoadingIcon = function () {
            window.createLoadingIcon(),
              document.querySelector(".products_loading") &&
                document
                  .querySelector(".products_loading")
                  .classList.add("show");
          }),
          (window.hideLoadingIcon = function () {
            document.querySelectorAll(".products_loading").length &&
              document
                .querySelectorAll(".products_loading")
                .forEach(function (t) {
                  t.remove();
                });
          });
      },
      8473: function () {
        !(function () {
          function t(t) {
            new MutationObserver(function (e) {
              document.querySelector(t) &&
                document
                  .querySelectorAll(
                    ".klevuQuickProductInnerBlock, .klevu-track-click"
                  )
                  .forEach(function (t) {
                    if (!t.classList.contains("updatedURL")) {
                      var e,
                        i = t.getAttribute("href");
                      (e =
                        "en" === window.Shopify.locale
                          ? i.replace(
                              ".com",
                              ".com" + Shopify.routes.root.replace(/.$/, "")
                            )
                          : i.replace(
                              "/" + window.Shopify.locale + "/",
                              window.Shopify.routes.root
                            )),
                        t.setAttribute("href", e),
                        t.classList.add("updatedURL");
                    }
                  });
            }).observe(document.body, { childList: !0, subtree: !0 });
          }
          t(".klevuQuickProductInnerBlock"), t(".klevu-track-click");
        })();
      },
    },
    e = {};
  function i(o) {
    var n = e[o];
    if (void 0 !== n) return n.exports;
    var r = (e[o] = { exports: {} });
    return t[o](r, r.exports, i), r.exports;
  }
  !(function () {
    "use strict";
    var t = function () {
      var t = ".navmenu-meganav-sidenav__items .navmenu-depth-3",
        e = ".icon-sidebar-arrow",
        i = ".navmenu-meganav-sidenav__items .sidebarLink",
        o = "[data-parent-color]",
        n = {
          sidebarNavDepth3: document.querySelectorAll(t),
          sidebarArrows: document.querySelectorAll(e),
          sidebarLinks: document.querySelectorAll(i),
          allColoredItems: document.querySelectorAll(o),
        };
      function r() {
        n.sidebarLinks.forEach(function (t) {
          var e = t.querySelector("a"),
            i = t.querySelector(".icon-sidebar-arrow"),
            o = t.querySelector(".navmenu-depth-3");
          e.addEventListener("mouseover", function () {
            n.sidebarNavDepth3.forEach(function (t) {
              t.style.display = "none";
            }),
              n.sidebarArrows.forEach(function (t) {
                t.style.display = "none";
              }),
              (i.style.display = "block"),
              (o.style.display = "grid");
          });
        });
      }
      return Object.freeze({
        init: function () {
          r(),
            n.allColoredItems.length > 0 &&
              n.allColoredItems.forEach(function (t) {
                var e = t.getAttribute("data-parent-color");
                e &&
                  e &&
                  "#000000" != e &&
                  (t.closest(".mega-menu")
                    ? (t
                        .closest(".mega-menu")
                        .querySelector(".list-menu__item span").style.color = e)
                    : t.closest(".side-bar") &&
                      (t
                        .closest(".side-bar")
                        .querySelector(".list-menu__item span").style.color =
                        e));
              });
        },
      });
    };
    function e(t, e) {
      var i =
        ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
      if (!i) {
        if (
          Array.isArray(t) ||
          (i = (function (t, e) {
            if (!t) return;
            if ("string" == typeof t) return o(t, e);
            var i = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === i && t.constructor && (i = t.constructor.name);
            if ("Map" === i || "Set" === i) return Array.from(t);
            if (
              "Arguments" === i ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
            )
              return o(t, e);
          })(t)) ||
          (e && t && "number" == typeof t.length)
        ) {
          i && (t = i);
          var n = 0,
            r = function () {};
          return {
            s: r,
            n: function () {
              return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
            },
            e: function (t) {
              throw t;
            },
            f: r,
          };
        }
        throw new TypeError(
          "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
        );
      }
      var a,
        s = !0,
        l = !1;
      return {
        s: function () {
          i = i.call(t);
        },
        n: function () {
          var t = i.next();
          return (s = t.done), t;
        },
        e: function (t) {
          (l = !0), (a = t);
        },
        f: function () {
          try {
            s || null == i.return || i.return();
          } finally {
            if (l) throw a;
          }
        },
      };
    }
    function o(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var i = 0, o = new Array(e); i < e; i++) o[i] = t[i];
      return o;
    }
    var n = function () {
        var t = ".klaviyo-form-wrapper",
          i = ".klaviyo-form-wrapper > div",
          o = '.klaviyo-form-wrapper [name="email"]',
          n = '.klaviyo-form-wrapper [data-testid="form-component"] > button',
          r = {
            klavioNewsletterWrapper: document.querySelector(t),
            klavioNewsletterForm: document.querySelector(i),
            formSubmit: document.querySelector(n),
            formInput: document.querySelector(o),
          };
        function a(e) {
          var i;
          e.target.closest(t) &&
            (s(r.klavioNewsletterForm),
            e.target.getAttribute("placeholder") &&
              ((i = e.target),
              document.activeElement == i
                ? i.classList.add("hide-placeholder")
                : i.classList.remove("hide-placeholder")));
        }
        function s(t) {
          t.querySelectorAll("*").forEach(function (t) {
            t.removeAttribute("style");
          });
        }
        return (
          document.addEventListener("focusin", a),
          document.addEventListener("focusout", a),
          document.addEventListener("click", a),
          Object.freeze({
            init: function () {
              var t;
              r.klavioNewsletterForm &&
                ((t = r.klavioNewsletterForm),
                new MutationObserver(function (i, o) {
                  var n,
                    r = e(i);
                  try {
                    for (r.s(); !(n = r.n()).done; ) {
                      var a = n.value;
                      ("childList" !== a.type &&
                        "attributes" !== a.type &&
                        "subtree" !== a.type) ||
                        (s(t),
                        setTimeout(function () {
                          o.disconnect();
                        }, 500));
                    }
                  } catch (t) {
                    r.e(t);
                  } finally {
                    r.f();
                  }
                }).observe(t, { childList: !0, attributes: !0, subtree: !0 }));
            },
          })
        );
      },
      r = function () {
        var t =
            "[data-js-price], .fs-product-price, .rebuy-money  span:not(.sr-only), .fs-large-text, [data-shg-product-target='product-price'], [data-order-summary-section] .product__price > span, [data-checkout-subtotal-price-target], [data-checkout-payment-due-target], [data-checkout-total-taxes-target], [data-checkout-total-shipping-target], [data-shipping-method] .content-box__emphasis, [data-review-section] .skeleton-while-loading--inline, [data-step='thank_you'] .payment-method-list__item__amount",
          e = ".js-price-container, .fs-timeline-detail, .ugc-slider",
          i = "js-formatted";
        function o(t) {
          var e = t.replaceAll(/\D/g, "");
          if (e && e.length > 0 && "" != e) return e;
        }
        function n() {
          return a()
            ? Shopify.checkout.presentment_currency
            : r()
            ? Shopify.Checkout.currency
            : Shopify.currency.active;
        }
        function r() {
          return !!Shopify.Checkout;
        }
        function a() {
          return !(!Shopify.Checkout || !Shopify.Checkout.isOrderStatusPage);
        }
        function s(t) {
          var e,
            i = n();
          if (
            ((t = parseInt(t)),
            (e = "GBP" === i ? "en-UK" : "EUR" === i ? "in" : "de-DE"),
            !isNaN(t))
          ) {
            var o = (t / 100)
              .toLocaleString(e, {
                style: "currency",
                currency: i.toLowerCase(),
              })
              .trim()
              .replaceAll("&nbsp;", "")
              .replaceAll(" ", "")
              .replaceAll("kr", "")
              .replaceAll(/kr\./g, "")
              .replaceAll("IDR", "")
              .replaceAll("DKK", "")
              .replaceAll("NOK", "")
              .replaceAll("PLN", "")
              .replaceAll("EUR", "")
              .replaceAll("GBP", "")
              .trim()
              .replaceAll(/\.00$/g, "")
              .replaceAll(/,00$/g, "");
            if (o) return o;
          }
        }
        return (
          (window.formatPrices = function (t) {
            document.querySelectorAll(t).forEach(function (t) {
              return (function (t) {
                var e = t.innerHTML.trim(),
                  r = o(e),
                  a =
                    ((l = n()),
                    "NOK" == l || "SEK" == l || "DKK" == l
                      ? " kr."
                      : "PLN" == l
                      ? " zł"
                      : "");
                var l;
                r &&
                  !t.classList.contains(i) &&
                  ("fs-large-text" != t.className
                    ? (t.innerHTML = s(r) + a)
                    : ((r = o(e.split("(")[1])),
                      (t.innerHTML = e.split("(")[0] + "(" + s(r) + a + ")")),
                  t.classList.add(i));
              })(t);
            });
          }),
          Object.freeze({
            init: function () {
              var i, o;
              (document.querySelectorAll(t).length > 0 ||
                document.querySelectorAll(e).length > 0) &&
                (r() || a()
                  ? (setTimeout(function () {
                      window.formatPrices(t);
                    }, 200),
                    document.addEventListener("page:change", function () {
                      return setTimeout(function () {
                        window.formatPrices(t);
                      }, 200);
                    }))
                  : ((i = e),
                    (o = new MutationObserver(function (e) {
                      e.forEach(function (e) {
                        e.addedNodes.forEach(function (e) {
                          e &&
                            e.querySelector &&
                            (e.querySelectorAll(t).length > 0 ||
                              e.hasAttribute("data-js-price")) &&
                            setTimeout(function () {
                              window.formatPrices(t);
                            }, 300);
                        });
                      });
                    })),
                    document.querySelectorAll(i).forEach(function (t) {
                      o.observe(t, {
                        childList: !0,
                        subtree: !0,
                        attributes: !0,
                      });
                    })));
            },
          })
        );
      };
    function a(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    function s(t, e) {
      for (var i = 0; i < e.length; i++) {
        var o = e[i];
        (o.enumerable = o.enumerable || !1),
          (o.configurable = !0),
          "value" in o && (o.writable = !0),
          Object.defineProperty(t, o.key, o);
      }
    }
    function l(t, e, i) {
      return (
        e && s(t.prototype, e),
        i && s(t, i),
        Object.defineProperty(t, "prototype", { writable: !1 }),
        t
      );
    }
    function c(t) {
      if (void 0 === t)
        throw new ReferenceError(
          "this hasn't been initialised - super() hasn't been called"
        );
      return t;
    }
    function u(t, e) {
      return (
        (u =
          Object.setPrototypeOf ||
          function (t, e) {
            return (t.__proto__ = e), t;
          }),
        u(t, e)
      );
    }
    function d(t, e) {
      if ("function" != typeof e && null !== e)
        throw new TypeError(
          "Super expression must either be null or a function"
        );
      (t.prototype = Object.create(e && e.prototype, {
        constructor: { value: t, writable: !0, configurable: !0 },
      })),
        Object.defineProperty(t, "prototype", { writable: !1 }),
        e && u(t, e);
    }
    function h(t) {
      return (
        (h =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        h(t)
      );
    }
    function f(t, e) {
      if (e && ("object" === h(e) || "function" == typeof e)) return e;
      if (void 0 !== e)
        throw new TypeError(
          "Derived constructors may only return object or undefined"
        );
      return c(t);
    }
    function m(t) {
      return (
        (m = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (t) {
              return t.__proto__ || Object.getPrototypeOf(t);
            }),
        m(t)
      );
    }
    function p() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return (
          Boolean.prototype.valueOf.call(
            Reflect.construct(Boolean, [], function () {})
          ),
          !0
        );
      } catch (t) {
        return !1;
      }
    }
    function y(t, e, i) {
      return (
        (y = p()
          ? Reflect.construct
          : function (t, e, i) {
              var o = [null];
              o.push.apply(o, e);
              var n = new (Function.bind.apply(t, o))();
              return i && u(n, i.prototype), n;
            }),
        y.apply(null, arguments)
      );
    }
    function v(t) {
      var e = "function" == typeof Map ? new Map() : void 0;
      return (
        (v = function (t) {
          if (
            null === t ||
            ((i = t), -1 === Function.toString.call(i).indexOf("[native code]"))
          )
            return t;
          var i;
          if ("function" != typeof t)
            throw new TypeError(
              "Super expression must either be null or a function"
            );
          if (void 0 !== e) {
            if (e.has(t)) return e.get(t);
            e.set(t, o);
          }
          function o() {
            return y(t, arguments, m(this).constructor);
          }
          return (
            (o.prototype = Object.create(t.prototype, {
              constructor: {
                value: o,
                enumerable: !1,
                writable: !0,
                configurable: !0,
              },
            })),
            u(o, t)
          );
        }),
        v(t)
      );
    }
    function g(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Boolean.prototype.valueOf.call(
              Reflect.construct(Boolean, [], function () {})
            ),
            !0
          );
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          o = m(t);
        if (e) {
          var n = m(this).constructor;
          i = Reflect.construct(o, arguments, n);
        } else i = o.apply(this, arguments);
        return f(this, i);
      };
    }
    var b = (function (t) {
      d(i, t);
      var e = g(i);
      function i() {
        var t;
        return (
          a(this, i),
          ((t = e.call(this)).classes = {
            active: "active",
            rightSide: "rightside",
            bottomSide: "bottomside",
            ecoConscious: "eco-conscious",
            sidebarConscious: "sidebar-conscious",
            fsc: "fsc",
          }),
          (t.elements = {
            ecoTooltip: document.getElementById("mobile-tooltip-eco-friendly"),
            fscTooltip: document.getElementById("mobile-tooltip-fsc"),
          }),
          window.innerWidth > 1024
            ? (t.addEventListener("mouseenter", t.open.bind(c(t))),
              t.addEventListener("mouseleave", t.close.bind(c(t))))
            : t.addEventListener("click", t.onClick.bind(c(t))),
          t
        );
      }
      return (
        l(i, [
          {
            key: "offset",
            value: function (t) {
              return { left: t.getBoundingClientRect().left };
            },
          },
          {
            key: "reposition",
            value: function () {
              var t = this.offset(this),
                e = document.querySelector(".filter-sidebar"),
                i = e
                  ? (window.innerWidth - e.offsetWidth) / 3
                  : window.innerWidth / 2,
                o = e ? 2 * i : i,
                n = e ? t.left - e.offsetWidth : t.left;
              if (n > i) {
                if (e && n < o) return;
                this.classList.add(this.classes.rightSide);
              } else this.classList.remove(this.classes.rightSide);
            },
          },
          {
            key: "repositionTop",
            value: function () {
              var t = this.getBoundingClientRect(),
                e = window.innerHeight / 2;
              t.top < e
                ? this.classList.add(this.classes.bottomSide)
                : this.classList.remove(this.classes.bottomSide);
            },
          },
          {
            key: "open",
            value: function () {
              this.classList.add(this.classes.active),
                this.classList.contains(this.classes.ecoConscious) &&
                  this.reposition(),
                this.classList.contains(this.classes.sidebarConscious) &&
                  this.repositionTop();
            },
          },
          {
            key: "close",
            value: function () {
              this.classList.remove(this.classes.active);
            },
          },
          {
            key: "closeMobile",
            value: function () {
              this.classList.remove("active"),
                this.removeEventListener("click", this.closeMobile);
            },
          },
          {
            key: "onClick",
            value: function () {
              this.classList.contains(this.classes.ecoConscious)
                ? (this.elements.ecoTooltip.classList.add(this.classes.active),
                  this.elements.ecoTooltip.addEventListener(
                    "click",
                    this.closeMobile
                  ))
                : this.classList.contains(this.classes.fsc) &&
                  (this.elements.fscTooltip.classList.add(this.classes.active),
                  this.elements.fscTooltip.addEventListener(
                    "click",
                    this.closeMobile
                  ));
            },
          },
        ]),
        i
      );
    })(v(HTMLElement));
    function w(t, e) {
      for (
        ;
        !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = m(t));

      );
      return t;
    }
    function S() {
      return (
        (S =
          "undefined" != typeof Reflect && Reflect.get
            ? Reflect.get
            : function (t, e, i) {
                var o = w(t, e);
                if (o) {
                  var n = Object.getOwnPropertyDescriptor(o, e);
                  return n.get
                    ? n.get.call(arguments.length < 3 ? t : i)
                    : n.value;
                }
              }),
        S.apply(this, arguments)
      );
    }
    function k(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Boolean.prototype.valueOf.call(
              Reflect.construct(Boolean, [], function () {})
            ),
            !0
          );
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          o = m(t);
        if (e) {
          var n = m(this).constructor;
          i = Reflect.construct(o, arguments, n);
        } else i = o.apply(this, arguments);
        return f(this, i);
      };
    }
    customElements.define("tool-tip", b);
    var L = (function (t) {
      d(i, t);
      var e = k(i);
      function i() {
        var t;
        return (
          a(this, i),
          ((t = e.call(this)).slider = t.querySelector('[id^="Slider-"]')),
          (t.sliderItems = t.querySelectorAll('[id^="Slide-"]')),
          (t.enableSliderLooping = !1),
          (t.currentPageElement = t.querySelector(".slider-counter--current")),
          (t.pageTotalElement = t.querySelector(".slider-counter--total")),
          (t.prevButton = t.querySelector('button[name="previous"]')),
          (t.nextButton = t.querySelector('button[name="next"]')),
          t.slider && t.nextButton
            ? (t.initPages(),
              new ResizeObserver(function (e) {
                return t.initPages();
              }).observe(t.slider),
              t.slider.addEventListener("scroll", t.update.bind(c(t))),
              t.prevButton.addEventListener(
                "click",
                t.onButtonClick.bind(c(t))
              ),
              t.nextButton.addEventListener(
                "click",
                t.onButtonClick.bind(c(t))
              ),
              (t.isDown = !1),
              t.startX,
              t.initScrollLeft,
              t)
            : f(t)
        );
      }
      return (
        l(i, [
          {
            key: "initPages",
            value: function () {
              (this.sliderItemsToShow = Array.from(this.sliderItems).filter(
                function (t) {
                  return t.clientWidth > 0;
                }
              )),
                this.sliderItemsToShow.length < 2 ||
                  ((this.sliderItemOffset =
                    this.sliderItemsToShow[1].offsetLeft -
                    this.sliderItemsToShow[0].offsetLeft),
                  (this.slidesPerPage = Math.floor(
                    (this.slider.clientWidth -
                      this.sliderItemsToShow[0].offsetLeft) /
                      this.sliderItemOffset
                  )),
                  (this.totalPages =
                    this.sliderItemsToShow.length - this.slidesPerPage + 1),
                  this.update());
            },
          },
          {
            key: "resetPages",
            value: function () {
              (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
                this.initPages();
            },
          },
          {
            key: "update",
            value: function () {
              var t = this.currentPage;
              (this.currentPage =
                Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
                this.currentPageElement &&
                  this.pageTotalElement &&
                  ((this.currentPageElement.textContent = this.currentPage),
                  (this.pageTotalElement.textContent = this.totalPages)),
                this.currentPage != t &&
                  this.dispatchEvent(
                    new CustomEvent("slideChanged", {
                      detail: {
                        currentPage: this.currentPage,
                        currentElement:
                          this.sliderItemsToShow[this.currentPage - 1],
                      },
                    })
                  ),
                this.enableSliderLooping ||
                  (this.isSlideVisible(this.sliderItemsToShow[0]) &&
                  0 === this.slider.scrollLeft
                    ? this.prevButton.setAttribute("disabled", "disabled")
                    : this.prevButton.removeAttribute("disabled"),
                  this.isSlideVisible(
                    this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
                  )
                    ? this.nextButton.setAttribute("disabled", "disabled")
                    : this.nextButton.removeAttribute("disabled"));
            },
          },
          {
            key: "isSlideVisible",
            value: function (t) {
              var e =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : 0,
                i = this.slider.clientWidth + this.slider.scrollLeft - e;
              return (
                t.offsetLeft + t.clientWidth <= i + 1 &&
                t.offsetLeft >= this.slider.scrollLeft
              );
            },
          },
          {
            key: "onButtonClick",
            value: function (t) {
              t.preventDefault();
              var e = t.currentTarget.dataset.step || 1;
              (this.slideScrollPosition =
                "next" === t.currentTarget.name
                  ? this.slider.scrollLeft + e * this.sliderItemOffset
                  : this.slider.scrollLeft - e * this.sliderItemOffset),
                this.slider.scrollTo({ left: this.slideScrollPosition });
            },
          },
        ]),
        i
      );
    })(v(HTMLElement));
    customElements.define("slider-component", L);
    var A = (function (t) {
      d(i, t);
      var e = k(i);
      function i() {
        var t;
        return (
          a(this, i),
          ((t = e.call(this)).sliderControlWrapper =
            t.querySelector(".slider-buttons")),
          (t.enableSliderLooping = !0),
          t.sliderControlWrapper
            ? ((t.sliderFirstItemNode =
                t.slider.querySelector(".slideshow__slide")),
              t.sliderItemsToShow.length > 0 && (t.currentPage = 1),
              (t.sliderControlLinksArray = Array.from(
                t.sliderControlWrapper.querySelectorAll(".slider-counter__link")
              )),
              t.sliderControlLinksArray.forEach(function (e) {
                return e.addEventListener("click", t.linkToSlide.bind(c(t)));
              }),
              t.slider.addEventListener(
                "scroll",
                t.setSlideVisibility.bind(c(t))
              ),
              t.setSlideVisibility(),
              "true" === t.slider.getAttribute("data-autoplay") &&
                t.setAutoPlay(),
              t)
            : f(t)
        );
      }
      return (
        l(i, [
          {
            key: "setAutoPlay",
            value: function () {
              (this.sliderAutoplayButton = this.querySelector(
                ".slideshow__autoplay"
              )),
                (this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
                this.sliderAutoplayButton.addEventListener(
                  "click",
                  this.autoPlayToggle.bind(this)
                ),
                this.addEventListener(
                  "mouseover",
                  this.focusInHandling.bind(this)
                ),
                this.addEventListener(
                  "mouseleave",
                  this.focusOutHandling.bind(this)
                ),
                this.addEventListener(
                  "focusin",
                  this.focusInHandling.bind(this)
                ),
                this.addEventListener(
                  "focusout",
                  this.focusOutHandling.bind(this)
                ),
                this.play(),
                (this.autoplayButtonIsSetToPlay = !0);
            },
          },
          {
            key: "onButtonClick",
            value: function (t) {
              S(m(i.prototype), "onButtonClick", this).call(this, t);
              var e = 1 === this.currentPage,
                o = this.currentPage === this.sliderItemsToShow.length;
              (!e && "previous" === t.currentTarget.name) ||
                (!o && "next" === t.currentTarget.name) ||
                (e && "previous" === t.currentTarget.name
                  ? (this.slideScrollPosition =
                      this.slider.scrollLeft +
                      this.sliderFirstItemNode.clientWidth *
                        this.sliderItemsToShow.length)
                  : o &&
                    "next" === t.currentTarget.name &&
                    (this.slideScrollPosition = 0),
                this.slider.scrollTo({
                  left: this.slideScrollPosition,
                  behavior: "instant",
                }));
            },
          },
          {
            key: "update",
            value: function () {
              S(m(i.prototype), "update", this).call(this),
                (this.sliderControlButtons = this.querySelectorAll(
                  ".slider-counter__link"
                )),
                this.prevButton.removeAttribute("disabled"),
                this.sliderControlButtons.length &&
                  (this.sliderControlButtons.forEach(function (t) {
                    t.classList.remove("slider-counter__link--active"),
                      t.removeAttribute("aria-current");
                  }),
                  this.sliderControlButtons[this.currentPage - 1].classList.add(
                    "slider-counter__link--active"
                  ),
                  this.sliderControlButtons[this.currentPage - 1].setAttribute(
                    "aria-current",
                    !0
                  ));
            },
          },
          {
            key: "autoPlayToggle",
            value: function () {
              this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
                this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
                (this.autoplayButtonIsSetToPlay =
                  !this.autoplayButtonIsSetToPlay);
            },
          },
          {
            key: "focusOutHandling",
            value: function (t) {
              var e =
                t.target === this.sliderAutoplayButton ||
                this.sliderAutoplayButton.contains(t.target);
              this.autoplayButtonIsSetToPlay && !e && this.play();
            },
          },
          {
            key: "focusInHandling",
            value: function (t) {
              (t.target === this.sliderAutoplayButton ||
                this.sliderAutoplayButton.contains(t.target)) &&
              this.autoplayButtonIsSetToPlay
                ? this.play()
                : this.autoplayButtonIsSetToPlay && this.pause();
            },
          },
          {
            key: "play",
            value: function () {
              this.slider.setAttribute("aria-live", "off"),
                clearInterval(this.autoplay),
                (this.autoplay = setInterval(
                  this.autoRotateSlides.bind(this),
                  this.autoplaySpeed
                ));
            },
          },
          {
            key: "pause",
            value: function () {
              this.slider.setAttribute("aria-live", "polite"),
                clearInterval(this.autoplay);
            },
          },
          {
            key: "togglePlayButtonState",
            value: function (t) {
              t
                ? (this.sliderAutoplayButton.classList.add(
                    "slideshow__autoplay--paused"
                  ),
                  this.sliderAutoplayButton.setAttribute(
                    "aria-label",
                    window.accessibilityStrings.playSlideshow
                  ))
                : (this.sliderAutoplayButton.classList.remove(
                    "slideshow__autoplay--paused"
                  ),
                  this.sliderAutoplayButton.setAttribute(
                    "aria-label",
                    window.accessibilityStrings.pauseSlideshow
                  ));
            },
          },
          {
            key: "autoRotateSlides",
            value: function () {
              var t =
                this.currentPage === this.sliderItems.length
                  ? 0
                  : this.slider.scrollLeft +
                    this.slider.querySelector(".slideshow__slide").clientWidth;
              this.currentPage === this.sliderItemsToShow.length
                ? this.slider.scrollTo({ left: t, behavior: "instant" })
                : this.slider.scrollTo({ left: t });
            },
          },
          {
            key: "setSlideVisibility",
            value: function () {
              var t = this;
              this.sliderItemsToShow.forEach(function (e, i) {
                var o = e.querySelector("a");
                i === t.currentPage - 1
                  ? (o && o.removeAttribute("tabindex"),
                    e.setAttribute("aria-hidden", "false"),
                    e.removeAttribute("tabindex"))
                  : (o && o.setAttribute("tabindex", "-1"),
                    e.setAttribute("aria-hidden", "true"),
                    e.setAttribute("tabindex", "-1"));
              });
            },
          },
          {
            key: "linkToSlide",
            value: function (t) {
              t.preventDefault();
              var e =
                this.slider.scrollLeft +
                this.sliderFirstItemNode.clientWidth *
                  (this.sliderControlLinksArray.indexOf(t.currentTarget) +
                    1 -
                    this.currentPage);
              this.slider.scrollTo({ left: e });
            },
          },
        ]),
        i
      );
    })(L);
    function _(t) {
      var e = (function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return (
            Boolean.prototype.valueOf.call(
              Reflect.construct(Boolean, [], function () {})
            ),
            !0
          );
        } catch (t) {
          return !1;
        }
      })();
      return function () {
        var i,
          o = m(t);
        if (e) {
          var n = m(this).constructor;
          i = Reflect.construct(o, arguments, n);
        } else i = o.apply(this, arguments);
        return f(this, i);
      };
    }
    customElements.define("slideshow-component", A);
    var T = (function (t) {
      d(i, t);
      var e = _(i);
      function i() {
        var t;
        return (
          a(this, i),
          (t = e.call(this)).onScrollBottom(),
          t.onScrollTop(),
          t.addEventListener("click", t.onClick.bind(c(t))),
          t
        );
      }
      return (
        l(i, [
          {
            key: "hide",
            value: function () {
              this.classList.add("hidden");
            },
          },
          {
            key: "show",
            value: function () {
              this.classList.remove("hidden");
            },
          },
          {
            key: "onScrollTop",
            value: function () {
              var t = 0,
                e = this;
              window.addEventListener("scroll", function () {
                var i =
                  window.pageYOffset || document.documentElement.scrollTop;
                i < t && i > window.innerHeight
                  ? e.show()
                  : i < t && i < window.innerHeight && e.hide(),
                  (t = i <= 0 ? 0 : i);
              });
            },
          },
          {
            key: "onScrollBottom",
            value: function () {
              var t = 0,
                e = this;
              window.addEventListener("scroll", function () {
                var i =
                  window.pageYOffset || document.documentElement.scrollTop;
                i > t && e.hide(), (t = i <= 0 ? 0 : i);
              });
            },
          },
          {
            key: "onClick",
            value: function () {
              var t = this;
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
                setTimeout(function () {
                  t.hide();
                }, 10);
            },
          },
        ]),
        i
      );
    })(v(HTMLElement));
    customElements.define("backtotop-button", T);
    var I = function () {
        var t = ".hide_until_ready .kuRECSContainer",
          e = ".recs-wrapper";
        return Object.freeze({
          init: function () {
            var i;
            document.querySelectorAll(e).length > 0 &&
              (i = setInterval(function () {
                document.querySelectorAll(t).forEach(function (t) {
                  t.querySelector(".card") &&
                    (t.closest(".hide_until_ready").classList.remove("hidden"),
                    clearInterval(i));
                });
              }, 100));
          },
        });
      },
      E =
        (i(4932),
        function () {
          var t = "localization-modal-form form",
            e = 'localization-modal-form [name="country_code"]',
            i = 'localization-modal-form [name="locale_code"]',
            o = "#PopupModal-Geolocation",
            n = "#closeModalButton",
            r = {
              formModal: document.querySelector(t),
              country_code_input: document.querySelector(e),
              language_code_input: document.querySelector(i),
              geolocation_modal: document.querySelector(o),
              stayOnGlobalBtn: document.querySelector(n),
            };
          function a(t, e, i) {
            var o = new Date();
            o.setTime(o.getTime() + 24 * i * 60 * 60 * 1e3);
            var n = "expires=" + o.toUTCString();
            document.cookie = t + "=" + e + ";" + n + ";path=/";
          }
          function s(t) {
            for (
              var e = t + "=",
                i = decodeURIComponent(document.cookie).split(";"),
                o = 0;
              o < i.length;
              o++
            ) {
              for (var n = i[o]; " " == n.charAt(0); ) n = n.substring(1);
              if (0 == n.indexOf(e)) return n.substring(e.length, n.length);
            }
            return "";
          }
          function l() {
            return new Promise(function (t, e) {
              (function (t) {
                return new Promise(function (e, i) {
                  fetch(t)
                    .then(function (t) {
                      return t.text();
                    })
                    .then(function (t) {
                      return e(t);
                    });
                });
              })("https://www.cloudflare.com/cdn-cgi/trace").then(function (e) {
                var i,
                  o = e.indexOf("loc="),
                  n = e
                    .substring(o + 4, o + 6)
                    .toLowerCase()
                    .trim();
                (i =
                  "" !== u()
                    ? u()
                    : (function (t) {
                        var e = "";
                        e =
                          -1 !==
                          [
                            "at",
                            "cz",
                            "be",
                            "ee",
                            "fi",
                            "gr",
                            "hu",
                            "ie",
                            "lv",
                            "lt",
                            "no",
                            "pt",
                            "sk",
                            "gb",
                          ].indexOf(t)
                            ? "en"
                            : "dk" === t
                            ? "da"
                            : "fr" === t
                            ? "fr"
                            : "de" === t
                            ? "de"
                            : "it" === t
                            ? "it"
                            : "nl" === t
                            ? "nl"
                            : "pl" === t
                            ? "pl"
                            : "es" === t
                            ? "es"
                            : "se" === t
                            ? "sv"
                            : "en";
                        return e;
                      })(n)),
                  t({ country: n, language: i });
              });
            });
          }
          function c() {
            return "fired" === s("user_uae_popup");
          }
          function u() {
            return window.Shopify.routes.root.split("/")[1].split("-")[0];
          }
          function d() {
            var t,
              e = "redirected" === s("user_is_redirected"),
              i =
                ((t = ""),
                2 === window.Shopify.routes.root.split("-").length
                  ? ("pt" ==
                      (t = window.Shopify.routes.root
                        .split("-")[0]
                        .replace("/", "")) && (t = "pt-PT"),
                    a(
                      "user_country",
                      window.Shopify.routes.root.split("-")[1].replace("/", ""),
                      30
                    ),
                    a("user_language", t, 30),
                    !0)
                  : "/" !== window.Shopify.routes.root &&
                    (a(
                      "user_language",
                      (t = window.Shopify.routes.root
                        .split("-")[0]
                        .replaceAll("/", "")),
                      30
                    ),
                    !1)),
              o = [
                "at",
                "be",
                "ee",
                "fi",
                "gr",
                "hu",
                "ie",
                "lv",
                "lt",
                "no",
                "pt",
                "sk",
                "gb",
                "dk",
                "fr",
                "de",
                "it",
                "nl",
                "pl",
                "es",
                "se",
                "cz",
              ];
            sessionStorage.getItem("selectedShippingCountryCode");
            e || i
              ? i ||
                (sessionStorage.getItem("session_redirected")
                  ? "" !== s("user_country") &&
                    "de" != s("user_country") &&
                    ((r.language_code_input.value = s("user_language")),
                    (r.country_code_input.value = s("user_country")),
                    r.formModal.submit())
                  : ("en" == s("user_language") && "de" == s("user_country")) ||
                    ((r.language_code_input.value = s("user_language")),
                    (r.country_code_input.value = s("user_country")),
                    sessionStorage.setItem("session_redirected", "redirected"),
                    r.formModal.submit()))
              : l().then(function (t) {
                  -1 !== o.indexOf(t.country)
                    ? ((r.language_code_input.value = t.language),
                      (r.country_code_input.value = t.country),
                      a("user_is_redirected", "redirected", 30),
                      a("user_language", t.language, 30),
                      a("user_country", t.country, 30),
                      r.formModal.submit())
                    : "ae" != t.country || c()
                    ? (a("user_is_redirected", "redirected", 30),
                      a("user_language", "en", 30),
                      a("user_country", "de", 30))
                    : (r.geolocation_modal.setAttribute("open", ""),
                      r.stayOnGlobalBtn.addEventListener("click", f),
                      a("user_uae_popup", "fired", 30));
                });
          }
          function h() {
            m("body #cookie-information-template-wrapper").then(function () {
              document
                .querySelector("body #cookie-information-template-wrapper")
                .classList.add("hidden");
            }),
              m("body > div > div.needsclick").then(function () {
                document
                  .querySelector("body > div > div.needsclick")
                  .classList.add("hidden");
              }),
              l().then(function (t) {
                ("ae" != t.country || c()) && f();
              });
          }
          function f() {
            m("body #cookie-information-template-wrapper").then(function () {
              document
                .querySelector("body #cookie-information-template-wrapper")
                .classList.remove("hidden");
            }),
              m("body > div > div.needsclick").then(function () {
                document
                  .querySelector("body > div > div.needsclick")
                  .classList.remove("hidden");
              });
          }
          function m(t) {
            return new Promise(function (e) {
              if (document.querySelector(t))
                return e(document.querySelector(t));
              var i = new MutationObserver(function (o) {
                document.querySelector(t) &&
                  (e(document.querySelector(t)), i.disconnect());
              });
              i.observe(document.body, { childList: !0, subtree: !0 });
            });
          }
          return Object.freeze({
            init: function () {
              var t;
              // console.log("Starting IP redirection."),
                h(),
                Shopify.designMode ||
                  ((t = window.location.host),
                  -1 ===
                    [
                      "flyingtiger.com",
                      "ftc-row-staging.com",
                      "ftc-row-dev.myshopify.com",
                    ].indexOf(t)) ||
                  d();
            },
          });
        }),
      C = function () {
        var t = {
          geolocation_modal: document.querySelector("#PopupModal-Geolocation"),
        };
        function e() {
          return (
            "fired" ===
            (function (t) {
              for (
                var e = t + "=",
                  i = decodeURIComponent(document.cookie).split(";"),
                  o = 0;
                o < i.length;
                o++
              ) {
                for (var n = i[o]; " " == n.charAt(0); ) n = n.substring(1);
                if (0 == n.indexOf(e)) return n.substring(e.length, n.length);
              }
              return "";
            })("user_uae_popup")
          );
        }
        function i() {
          var i;
          ((i = "body[class*=orbe-country-code--]"),
          new Promise(function (t) {
            if (document.querySelector(i)) return t(document.querySelector(i));
            var e = new MutationObserver(function (o) {
              document.querySelector(i) &&
                (t(document.querySelector(i)), e.disconnect());
            });
            e.observe(document.body, { childList: !0, subtree: !0 });
          })).then(function () {
            document
              .querySelector("body")
              .classList.contains("orbe-country-code--AE") &&
              (e() ||
                (t.geolocation_modal.setAttribute("open", ""),
                (function (t, e, i) {
                  var o = new Date();
                  o.setTime(o.getTime() + 24 * i * 60 * 60 * 1e3);
                  var n = "expires=" + o.toUTCString();
                  document.cookie = t + "=" + e + ";" + n + ";path=/";
                })("user_uae_popup", "fired", 30)));
          });
        }
        return Object.freeze({
          init: function () {
            i();
          },
        });
      };
    function q(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var i = 0, o = new Array(e); i < e; i++) o[i] = t[i];
      return o;
    }
    function P(t) {
      return (
        (function (t) {
          if (Array.isArray(t)) return q(t);
        })(t) ||
        (function (t) {
          if (
            ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
            null != t["@@iterator"]
          )
            return Array.from(t);
        })(t) ||
        (function (t, e) {
          if (t) {
            if ("string" == typeof t) return q(t, e);
            var i = Object.prototype.toString.call(t).slice(8, -1);
            return (
              "Object" === i && t.constructor && (i = t.constructor.name),
              "Map" === i || "Set" === i
                ? Array.from(t)
                : "Arguments" === i ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
                ? q(t, e)
                : void 0
            );
          }
        })(t) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    var O = (function () {
      function t(e, i) {
        a(this, t),
          (this.defaults = {
            allProducts: document.querySelectorAll(".card [data-wishlist]"),
            wishlistCounter: document.querySelector(
              ".icon--wishlist__quantity"
            ),
            pageBody: document.querySelector("#fuse-body"),
            wishlistFooter: document.querySelector(".wishlist__footer"),
            addAllToCart: document.querySelector("#addAllToCart"),
            removeAllFromWishlist: document.querySelector(
              "#removeAllFromWishlist"
            ),
            addAllToCartLoading: document.querySelector(
              ".loading-overlay__spinner"
            ),
            wishlistItems: document.querySelector("#wishlistItems"),
            emtyCTA: document.querySelector(".rich-text__blocks a"),
          }),
          (this.nodeSelectors = {
            allProducts: this.defaults.allProducts,
            wishlistCounter: this.defaults.wishlistCounter,
            pageBody: this.defaults.pageBody,
            wishlistFooter: this.defaults.wishlistFooter,
            addAllToCart: this.defaults.addAllToCart,
            addAllToCartLoading: this.defaults.addAllToCartLoading,
            removeAllFromWishlist: this.defaults.removeAllFromWishlist,
            wishlistItems: this.defaults.wishlistItems,
            emtyCTA: this.defaults.emtyCTA,
          }),
          (this.wishlistProducts = []),
          (this.cookieData = { name: "_ftcWishlist", value: [] });
      }
      return (
        l(t, [
          {
            key: "writeToLocalStorage",
            value: function (t, e) {
              localStorage.setItem(t, e);
            },
          },
          {
            key: "getItemFromLocalStorage",
            value: function (t) {
              var e = localStorage.getItem(t);
              return e || "";
            },
          },
          {
            key: "getLiveSiteProds",
            value: function () {
              for (
                var t = this.getItemFromLocalStorage("wishlist_product_ids")
                    ? JSON.parse(
                        this.getItemFromLocalStorage("wishlist_product_ids")
                      )
                    : [],
                  e = this.getItemFromLocalStorage("items")
                    ? JSON.parse(this.getItemFromLocalStorage("items"))
                    : [],
                  i = [],
                  o = 0;
                o < t.length;
                o++
              ) {
                var n = t[o] + "," + e[o];
                i.push(n);
              }
              return i;
            },
          },
          {
            key: "getUniqueProducts",
            value: function () {
              var t = this.getLiveSiteProds(),
                e = this.getItemFromLocalStorage(this.cookieData.name)
                  ? JSON.parse(
                      this.getItemFromLocalStorage(this.cookieData.name)
                    )
                  : [],
                i = [].concat(P(t), P(e));
              return i.filter(function (t, e) {
                return i.indexOf(t) === e;
              });
            },
          },
          {
            key: "removeDuplicateStrings",
            value: function (t) {
              return t.filter(function (e, i) {
                t.indexOf(e);
              });
            },
          },
          {
            key: "initWishilistSync",
            value: function () {
              var t = this.getUniqueProducts();
              this.getItemFromLocalStorage("wishlistItemsSynch") ||
                ((this.cookieData.value = t),
                this.writeToLocalStorage("wishlistItemsSynch", !0),
                this.writeToLocalStorage(
                  this.cookieData.name,
                  JSON.stringify(this.cookieData.value)
                ));
            },
          },
          {
            key: "createCookie",
            value: function (t) {
              this.setCookie(this.cookieData.name, this.cookieData.value);
            },
          },
          {
            key: "setCookie",
            value: function (t, e) {
              document.cookie =
                t + "=" + e + ";expires= Fri, 31 Dec 9999 23:59:59 GMT;path=/";
            },
          },
          {
            key: "getCookie",
            value: function (t) {
              for (
                var e = t + "=",
                  i = decodeURIComponent(document.cookie).split(";"),
                  o = 0;
                o < i.length;
                o++
              ) {
                for (var n = i[o]; " " == n.charAt(0); ) n = n.substring(1);
                if (0 == n.indexOf(e)) return n.substring(e.length, n.length);
              }
              return "";
            },
          },
          {
            key: "checkCookie",
            value: function () {
              return "" != this.getCookie(this.cookieData.name);
            },
          },
          {
            key: "removeWishlistItem",
            value: function (t) {
              var e = document.querySelectorAll(".wishlist__row");
              e.length > 0 &&
                e.forEach(function (e) {
                  e.getAttribute("wishlist-id") == t &&
                    e.closest(".wishlist__row").remove();
                });
            },
          },
          {
            key: "addItemsToWishList",
            value: function () {
              var t = this,
                e = !!document.querySelector(".page-wishlist");
              document.addEventListener("click", function (i) {
                if (i.target.closest("[data-wishlist]")) {
                  var o = i.target.closest("[data-wishlist]"),
                    n = o.getAttribute("wishlist-id"),
                    r = n + "," + o.getAttribute("data-product-handle");
                  o.classList.contains("wishlist-added")
                    ? (t.removeItemFromWishlist(n),
                      e &&
                        (t.updateDOMOnItemRemoval(n), t.removeWishlistItem(n)),
                      t.removeHeartIcon(r))
                    : (t.cookieData.value.push(r),
                      e && t.getSingleProductDetailsData(r)),
                    t.writeToLocalStorage(
                      t.cookieData.name,
                      JSON.stringify(t.cookieData.value)
                    ),
                    t.showSavedItems(),
                    t.manageEmptyWishlist();
                }
              });
            },
          },
          {
            key: "updateDOMOnItemRemoval",
            value: function (t) {
              document
                .querySelectorAll("[data-wishlist]")
                .forEach(function (e) {
                  e.getAttribute("wishlist-id") == t &&
                    e.classList.contains("wishlist-added") &&
                    e.classList.remove("wishlist-added");
                });
            },
          },
          {
            key: "removeItemFromWishlist",
            value: function (t) {
              var e = this.cookieData.value.filter(function (e) {
                return e.split(",")[0] != t;
              });
              (this.cookieData.value = e),
                this.writeToLocalStorage(
                  this.cookieData.name,
                  JSON.stringify(e)
                ),
                this.showSavedItems(),
                this.manageEmptyWishlist();
            },
          },
          {
            key: "removeHeartIcon",
            value: function (t) {
              var e = t.split(",")[0];
              document
                .querySelectorAll(".card [data-wishlist]")
                .forEach(function (t) {
                  t.getAttribute("wishlist-id") === e &&
                    t.classList.contains("wishlist-added") &&
                    t.classList.remove("wishlist-added");
                });
            },
          },
          {
            key: "showSavedItems",
            value: function () {
              var t = this;
              if (
                this.getItemFromLocalStorage(this.cookieData.name).length > 0
              ) {
                var e = JSON.parse(
                  this.getItemFromLocalStorage(this.cookieData.name)
                );
                this.cookieData.value.forEach(function (e) {
                  t.addHeartIcon(e);
                });
              }
            },
          },
          {
            key: "addHeartIcon",
            value: function (t) {
              var e = parseInt(t.split(",")[0]);
              document
                .querySelectorAll(".card [data-wishlist]")
                .forEach(function (t) {
                  parseInt(t.getAttribute("wishlist-id")) !== e ||
                    t.classList.contains("wishlist-added") ||
                    t.classList.add("wishlist-added");
                });
            },
          },
          {
            key: "updateComponentData",
            value: function () {
              if (
                this.getItemFromLocalStorage(this.cookieData.name).length > 0
              ) {
                var t = JSON.parse(
                  this.getItemFromLocalStorage(this.cookieData.name)
                );
                this.cookieData.value = t;
              }
            },
          },
          {
            key: "addToBagHTML",
            value: function (t, e) {
              var i = JSON.parse(
                  document
                    .getElementById("wishlistDynamicStrings")
                    .innerHTML.replace(/(\r\n|\n|\r)/gm, "")
                ),
                o = "";
              (0 != e.available && null != e.available) ||
                ((o = i.notify_me),
                e.tags.includes("Tag:showOutOfStock") || (o = i.sold_out));
              return e.available && e.price > 0
                ? '<div class="wishlist__col button-add">\n                <product-form>\n                    <form method="post" action="/cart/add" id="quick-add-template--'
                    .concat(
                      e.id,
                      '" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">\n                        <input type="hidden" name="form_type" value="product">\n                        <input type="hidden" name="id" value="'
                    )
                    .concat(
                      e.variants[0].id,
                      '">\n                        <button id="quick-add-template--'
                    )
                    .concat(
                      e.variants[0].id,
                      '-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--add-to-cart" aria-haspopup="dialog" aria-labelledby="quick-add-'
                    )
                    .concat(
                      e.variants[0].id,
                      '-submit">                \n                            <span> \n                            '
                    )
                    .concat(
                      i.addToCartText,
                      '\n                            </span>\n                            <div class="loading-overlay__spinner hidden" bis_skin_checked="1">\n                                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\n                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\n                                </svg>\n                            </div>\n                        </button>\n                    </form>\n                </product-form> \n            </div>'
                    )
                : !e.available && e.tags.includes("Tag:showOutOfStock")
                ? '\n              <div class="wishlist__col button-add">\n                <div class="klaviyo-product-container" id=\'klaviyo-data-handle-'
                    .concat(e.handle, "' data-klaviyo-handle=\"")
                    .concat(
                      e.handle,
                      '" >\n                     <div class="klaviyo-button-container">\n                          <a class="quick-add__submit button button—-notify-me klaviyo-bis-trigger" id="wishlist-bis" href="#" data-klaviyo-handle="'
                    )
                    .concat(e.handle, '" tabindex="0">')
                    .concat(
                      o,
                      "</a>\n                     </div>\n                </div>\n             </div>"
                    )
                : e.price > 0
                ? '\n            <div class="wishlist__col button-add">\n                <button id="quick-add-template--'
                    .concat(
                      e.variants[0].id,
                      '-submit" type="submit" name="add" class="quick-add__submit button button--full-width button--add-to-cart" aria-haspopup="dialog" aria-labelledby="quick-add-'
                    )
                    .concat(
                      e.variants[0].id,
                      '-submit" disabled>                \n                    <span> \n                    '
                    )
                    .concat(
                      o,
                      "\n                    </span>\n                </button>\n            </div>"
                    )
                : '\n            <div class="wishlist__col"> </div>';
            },
          },
          {
            key: "createProductItemHTMLString",
            value: function (t, e) {
              var i = JSON.parse(
                  document
                    .getElementById("wishlistDynamicStrings")
                    .innerHTML.replace(/(\r\n|\n|\r)/gm, "")
                ),
                o = this.addToBagHTML(t, e),
                n = " ";
              return (
                e.price > 0
                  ? (n +=
                      ' \n            <div class="wishlist__col product_price">\n                <p class="product-item-price"  data-js-price="'
                        .concat(e.variants[0].price, '">€')
                        .concat(
                          e.variants[0].price,
                          "</p>\n            </div>"
                        ))
                  : (n +=
                      ' <div class="wishlist__col product_price">\n              <p class="product-item-price"> </p>\n           </div>'),
                '<div class="wishlist__row content" data-availability="'
                  .concat(e.available, '"  data-variant-id="')
                  .concat(e.variants[0].id, '" data-product-id="')
                  .concat(e.id, '" wishlist-id="')
                  .concat(e.id, '" data-product-price="')
                  .concat(e.variants[0].price, '" data-product-handle="')
                  .concat(e.handle, '" data-product-title="')
                  .concat(
                    e.title,
                    '">\n                <div class="wishlist__col product_image">\n                    <a href="'
                  )
                  .concat(e.url, '">\n                        <img src="')
                  .concat(e.media[0].src, '" alt="')
                  .concat(
                    e.media[0].alt,
                    '" width="" height="">\n                    </a>   \n                </div>\n                <div class="wishlist__col wishlist__col-grid data">\n                    <div class="wishlist__col product_title">\n                        <a href="'
                  )
                  .concat(e.url, '">\n                            <p>')
                  .concat(
                    e.title,
                    "</p>\n                        </a>   \n                    </div>\n                    "
                  )
                  .concat(n, "\n                    ")
                  .concat(
                    o,
                    '\n                    <div class="wishlist__col button-remove">\n                        <button class="button button--secondary" id="removeFromWishlist"><span>'
                  )
                  .concat(
                    i.removeFromCartText,
                    "</span></button>\n                    </div>\n                </div>\n            </div>"
                  )
              );
            },
          },
          {
            key: "getAllProductDetailsData",
            value: function () {
              var t = this,
                e = "",
                i = this;
              this.cookieData.value.forEach(function (o) {
                var n = o.split(",")[1],
                  r = window.Shopify.routes.root + "products/" + n + ".js";
                fetch(r)
                  .then(function (t) {
                    return t.json();
                  })
                  .then(function (n) {
                    (e = i.createProductItemHTMLString(o, n)),
                      i.nodeSelectors.wishlistItems.insertAdjacentHTML(
                        "beforeend",
                        e
                      ),
                      t._removeItemsAfterAppend(),
                      t.manageEmptyWishlist();
                  });
              });
            },
          },
          {
            key: "getSingleProductDetailsData",
            value: function (t) {
              var e,
                i = this,
                o = (t.split(",")[0], t.split(",")[1]),
                n = "",
                r = window.Shopify.routes.root + "products/" + o + ".js",
                a = this;
              fetch(r)
                .then(function (t) {
                  return t.json();
                })
                .then(function (o) {
                  (e = o),
                    (n = i.createProductItemHTMLString(t, e)),
                    a.nodeSelectors.wishlistItems.insertAdjacentHTML(
                      "beforeend",
                      n
                    );
                });
            },
          },
          {
            key: "addAllToCart",
            value: function () {
              var t = this;
              this.nodeSelectors.addAllToCart.addEventListener(
                "click",
                function (e) {
                  var i = document.querySelectorAll(
                    '.wishlist-items [data-availability="true"]'
                  );
                  if (i.length > 0) {
                    var o = "",
                      n = "";
                    i.forEach(function (t, e) {
                      var i = t.attributes["data-variant-id"].value;
                      "true" === t.attributes["data-availability"].value &&
                        (n += '{ "id": '.concat(i, ', "quantity": 1},'));
                    }),
                      n.charAt(n.length - 1 === ",") &&
                        (n = n.replace(/,$/, "")),
                      (o += '{ "items": ['.concat(n, "]}")),
                      t.addProductToBag(JSON.parse(o));
                  }
                }
              );
            },
          },
          {
            key: "addProductToBag",
            value: function (t) {
              var e = this;
              fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(t),
              })
                .then(function (t) {
                  return t.json();
                })
                .then(function (t) {
                  var i = e.fetchConfig("javascript");
                  (i.headers["X-Requested-With"] = "XMLHttpRequest"),
                    delete i.headers["Content-Type"];
                  var o = new FormData(),
                    n = document.querySelector(
                      'drawer-component[data-drawer="cart"]'
                    );
                  o.append(
                    "sections",
                    n.getSectionsToRender().map(function (t) {
                      return t.id;
                    })
                  ),
                    o.append("sections_url", window.location.pathname),
                    n.setActiveElement(document.activeElement),
                    (i.body = o),
                    fetch("".concat(window.routes.cart_update_url), i)
                      .then(function (t) {
                        return t.json();
                      })
                      .then(function (t) {
                        n.renderContents(t);
                      })
                      .catch(function (t) {
                        console.error(t);
                      })
                      .finally(function () {
                        e.nodeSelectors.addAllToCart.removeAttribute(
                          "aria-disabled"
                        ),
                          e.nodeSelectors.addAllToCartLoading.classList.add(
                            "hidden"
                          );
                      });
                })
                .catch(function (t) {
                  console.error("Error:", t);
                });
            },
          },
          {
            key: "addToCardAfterAppendProducts",
            value: function () {
              var t = this,
                e = document.querySelector("#wishlistContent");
              new MutationObserver(function (e) {
                e.forEach(function (e) {
                  "childList" === e.type &&
                    document
                      .querySelectorAll("#addToCart")
                      .forEach(function (e) {
                        e.addEventListener("click", function () {
                          var i = {
                            items: [
                              {
                                id: e
                                  .closest(".wishlist__row")
                                  .getAttribute("data-variant-id"),
                                quantity: 1,
                              },
                            ],
                          };
                          t.addProductToBag(i);
                        });
                      });
                });
              }).observe(e, {
                attributes: !0,
                childList: !0,
                characterData: !0,
              });
            },
          },
          {
            key: "removeItemsAfterAppend",
            value: function () {
              var t = this,
                e = document.querySelector("#wishlistItems");
              new MutationObserver(function (e) {
                e.forEach(function (e) {
                  "childList" === e.type &&
                    (document
                      .querySelectorAll("#removeFromWishlist")
                      .forEach(function (e) {
                        var i = e
                          .closest(".wishlist__row")
                          .getAttribute("wishlist-id");
                        e.addEventListener("click", function () {
                          e.closest(".wishlist__row").remove(),
                            t.updateDOMOnItemRemoval(i),
                            t.removeItemFromWishlist(i);
                        });
                      }),
                    t.removeAllFromWishlist());
                });
              }).observe(e, {
                attributes: !0,
                childList: !0,
                characterData: !0,
              });
            },
          },
          {
            key: "_removeItemsAfterAppend",
            value: function () {
              var t = this,
                e = document.querySelectorAll("#removeFromWishlist");
              e &&
                (e.forEach(function (e) {
                  var i = e
                    .closest(".wishlist__row")
                    .getAttribute("wishlist-id");
                  e.addEventListener("click", function () {
                    e.closest(".wishlist__row").remove(),
                      t.updateDOMOnItemRemoval(i),
                      t.removeItemFromWishlist(i);
                  });
                }),
                this.removeAllFromWishlist(),
                this.manageEmptyWishlist());
            },
          },
          {
            key: "removeAllFromWishlist",
            value: function () {
              var t = this;
              this.nodeSelectors.removeAllFromWishlist &&
                this.nodeSelectors.removeAllFromWishlist.addEventListener(
                  "click",
                  function () {
                    (t.cookieData.value = []),
                      t.writeToLocalStorage(
                        t.cookieData.name,
                        t.cookieData.value
                      ),
                      (t.nodeSelectors.wishlistCounter.innerText =
                        t.cookieData.value.length);
                    var e = document.querySelectorAll(
                      ".wishlist-items .wishlist__row"
                    );
                    e &&
                      e.forEach(function (e) {
                        e.remove(),
                          t.updateDOMOnItemRemoval(
                            e.getAttribute("wishlist-id")
                          );
                      }),
                      t.manageEmptyWishlist();
                  }
                );
            },
          },
          {
            key: "manageEmptyWishlist",
            value: function () {
              if (!!document.querySelector(".page-wishlist")) {
                var t = document.querySelectorAll(
                  '.wishlist-items [data-availability="true"]'
                );
                t.length > 1
                  ? this.nodeSelectors.addAllToCart.classList.remove(
                      "visibility-hidden"
                    )
                  : this.nodeSelectors.addAllToCart.classList.add(
                      "visibility-hidden"
                    ),
                  t.length <= 1 || this.cookieData.value.length <= 1
                    ? this.nodeSelectors.removeAllFromWishlist.classList.add(
                        "visibility-hidden"
                      )
                    : this.nodeSelectors.removeAllFromWishlist.classList.remove(
                        "visibility-hidden"
                      ),
                  0 == this.cookieData.value.length
                    ? (this.nodeSelectors.wishlistFooter.classList.add(
                        "visibility-hidden"
                      ),
                      this.nodeSelectors.emtyCTA.classList.remove(
                        "visibility-hidden"
                      ))
                    : (this.nodeSelectors.emtyCTA.classList.add(
                        "visibility-hidden"
                      ),
                      this.nodeSelectors.wishlistFooter.classList.remove(
                        "visibility-hidden"
                      ));
              }
            },
          },
          {
            key: "shareMyWishlist",
            value: function () {
              var t = this,
                e =
                  (this.cookieData.value,
                  "subject=" +
                    JSON.parse(
                      document
                        .getElementById("wishlistDynamicStrings")
                        .innerHTML.replace(/(\r\n|\n|\r)/gm, "")
                    ).my_wishlist_mail_subject),
                i = "",
                o = document.querySelector(".share-email a"),
                n = document.querySelector("#wishlistItems");
              new MutationObserver(function (n) {
                (i = "mailto:?".concat(e, "&body=")),
                  n.forEach(function (e) {
                    if ("childList" === e.type) {
                      var n = document.querySelectorAll(
                        "#wishlistContent .content"
                      );
                      (i += t.createDynamicShareContent(n)),
                        o.setAttribute("href", i);
                    }
                  });
              }).observe(n, {
                attributes: !0,
                childList: !0,
                characterData: !0,
              });
            },
          },
          {
            key: "createDynamicShareContent",
            value: function (t) {
              var e = this,
                i =
                  (document
                    .querySelector("#wishlistContent")
                    .getAttribute("data-country-iso-code"),
                  "");
              return (
                t.forEach(function (t) {
                  var o = t.getAttribute("data-product-handle"),
                    n = t.getAttribute("data-product-title"),
                    r = e.handlePrice(t.getAttribute("data-product-price"));
                  "en" == window.Shopify.locale
                    ? (i +=
                        n +
                        " (".concat(r, ") ") +
                        "%0D%0A" +
                        window.location.origin +
                        "/products/" +
                        o +
                        "%0D%0A%0D%0A")
                    : (i +=
                        n +
                        " (".concat(r, ") ") +
                        "%0D%0A" +
                        window.location.origin +
                        window.Shopify.routes.root +
                        "products/".concat(o) +
                        "%0D%0A%0D%0A");
                }),
                i
              );
            },
          },
          {
            key: "fetchConfig",
            value: function () {
              var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : "json";
              return {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/".concat(t),
                },
              };
            },
          },
          {
            key: "handlePrice",
            value: function (t) {
              var e = this.getPriceFromText(t),
                i = this.getCurrencySymbol();
              return this.formatPricesToLocaleString(e) + i;
            },
          },
          {
            key: "formatPricesToLocaleString",
            value: function (t) {
              var e,
                i = this.getCurrency();
              if (
                ((t = parseInt(t)),
                (e = "GBP" === i ? "en-UK" : "EUR" === i ? "in" : "de-DE"),
                !isNaN(t))
              ) {
                var o = (t / 100)
                  .toLocaleString(e, {
                    style: "currency",
                    currency: i.toLowerCase(),
                  })
                  .trim()
                  .replaceAll("&nbsp;", "")
                  .replaceAll(" ", "")
                  .replaceAll("kr", "")
                  .replaceAll(/kr\./g, "")
                  .replaceAll("SEK", "")
                  .replaceAll("DKK", "")
                  .replaceAll("NOK", "")
                  .replaceAll("PLN", "")
                  .replaceAll("EUR", "")
                  .replaceAll("GBP", "")
                  .trim()
                  .replaceAll(/\.00$/g, "")
                  .replaceAll(/,00$/g, "");
                if (o) return o;
              }
            },
          },
          {
            key: "getCurrency",
            value: function () {
              return Shopify.currency.active;
            },
          },
          {
            key: "getPriceFromText",
            value: function (t) {
              var e = t.replaceAll(/\D/g, "");
              if (e && e.length > 0 && "" != e) return e;
            },
          },
          {
            key: "getCurrencySymbol",
            value: function () {
              var t = this.getCurrency();
              return "NOK" == t || "SEK" == t || "DKK" == t
                ? " kr."
                : "PLN" == t
                ? " zł"
                : "";
            },
          },
          {
            key: "init",
            value: function () {
              var t = !!document.querySelector(".page-wishlist");
              this.initWishilistSync(),
                this.updateComponentData(),
                this.showSavedItems(),
                t &&
                  (this.getAllProductDetailsData(),
                  this.removeItemsAfterAppend(),
                  this.addAllToCart(),
                  this.manageEmptyWishlist(),
                  this.shareMyWishlist()),
                this.addItemsToWishList();
            },
          },
        ]),
        t
      );
    })();
    i(8473), i(8067), i(8798), i(6426);
    document.addEventListener("DOMContentLoaded", function () {
      t().init(),
        n().init(),
        r().init(),
        "true" ==
        document.querySelector("body").getAttribute("ip-redirection-enabled")
          ? E().init()
          : C().init(),
        new O().init(),
        I().init();
    });
  })();
})();
